import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string'
import { LOAD_DRIVER_FOR_SCHEDULING, GET_DRIVER_FOR_SCHEDULING, CLEAR_DRIVER_FOR_SCHEDULING } from "../types";
import {
  DEFAULT_GET_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { DRIVER_FOR_SCHEDULING_ENDPOINT } from '../../config/endpoints';


const loadDriverForScheduling = (status) => (dispatch) =>
  dispatch({
    type: LOAD_DRIVER_FOR_SCHEDULING,
    payload: status,
  });

const getDriverForScheduling = ({ fromDateString, toDateString, itineraryDirection, homeBaseLocationId, serviceTypes, showNorteChico }) => async (dispatch) => {
  try {
    dispatch(loadDriverForScheduling(true));
    const url = `${DRIVER_FOR_SCHEDULING_ENDPOINT}?${QueryString.stringify({ fromDateString, toDateString, itineraryDirection, homeBaseLocationId, serviceTypes, showNorteChico })}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const schedulingData = await response.json();
    dispatch({
      type: GET_DRIVER_FOR_SCHEDULING,
      payload: schedulingData,
    });
  } catch (error) {
    toastr.error('Error', 'Failed to fetch driver scheduling data');
  } finally {
    dispatch(loadDriverForScheduling(false));
  }
};

const clearDriverForScheduling = () => (dispatch) =>
  dispatch({
    type: CLEAR_DRIVER_FOR_SCHEDULING,
  });

const exportDriverForSchedulingFile = async (formValues) => async (dispatch) => {
  try {
    dispatch(loadDriverForScheduling(true));
    const url = `${DRIVER_FOR_SCHEDULING_ENDPOINT}/export?${QueryString.stringify(
      formValues,
    )}`;
    const response = await fetch(url, {
      ...DEFAULT_GET_CONFIG,
    });
    await isErrorResponse(response, null, dispatch);
    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'DriverForScheduling.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    toastr.error('Error', 'Failed to export driver scheduling data');
  } finally {
    dispatch(loadDriverForScheduling(false));
  }
}


export { loadDriverForScheduling, getDriverForScheduling, clearDriverForScheduling, exportDriverForSchedulingFile }